/**
 * @file
 * @prettier
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeNewAccountPaperlessPage() {
  customValidationInit(false);
  aspControlValidationInit();

  $(document).tooltip();
}
